import script from "./AchievementsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementsList.vue?vue&type=script&setup=true&lang=js"

import "./AchievementsList.vue?vue&type=style&index=0&id=2c914ee8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c914ee8"]])

export default __exports__